<template>
    <div>
        <v-card id="details" :loading="loading" height="100vh">
            <v-card-title ref="title">
                <v-btn small icon @click="close" color="primary" class="mr-2">
                    <v-icon>
                        mdi-close
                    </v-icon>
                </v-btn>
                <h3>NEW RESERVE</h3>
            </v-card-title>
            <v-divider class="ml-4 mr-5" />
            <v-card-subtitle class="mb-2" ref="subtitle">
                <div>
                    <p class="pa-0 ma-0">
                        <strong>CODE: </strong>{{ item.code }}
                    </p>
                </div>
                <div>
                    <p class="pa-0 ma-0">
                        <strong>Description: </strong>{{ item.description }}
                    </p>
                </div>
            </v-card-subtitle>
            <v-card-text class="mt-n5">
                <v-row no-gutters class="mb-6" ref="searchField">
                    <v-col cols="4">
                        <v-autocomplete
                            v-model="selectedProject"
                            :items="projects"
                            item-text="name"
                            item-value="id"
                            prepend-icon="mdi-account-hard-hat"
                            hide-details
                            label="Select Project"
                            :readonly="!!projectId"
                        >
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-data-table
                    id="virtual-scroll-table"
                    :headers="headers"
                    :items="tableItems"
                    class="elevation-0"
                    :mobile-breakpoint="0"
                    :loading="loading"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                    :height="height"
                    calculate-widths
                >
                    <!--ITEMS-->
                    <template v-slot:[`item.project_name`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <p class="my-0" v-bind="attrs" v-on="on">
                                    {{
                                        item.project_name === ''
                                            ? 'Free'
                                            : item.project_name
                                    }}
                                    <v-icon
                                        v-if="item.isGenericReserveRow"
                                        small
                                        color="primary"
                                        class="ml-1"
                                    >
                                        mdi-information-outline
                                    </v-icon>
                                </p>
                            </template>
                            <span>
                                {{
                                    item.isGenericReserveRow
                                        ? 'Approved generic project reserve not yet fully reflected in the SAP stock file (qty shown is reserve total minus SAP project lines for this material and store).'
                                        : item.project_name === ''
                                        ? 'No PM'
                                        : item.pm_name
                                }}
                            </span>
                        </v-tooltip>
                    </template>

                    <template v-slot:[`item.free_use`]="{ item }">
                        <p class="my-0">
                            {{ getDisplayQuantity(item) }}
                        </p>
                    </template>

                    <template v-slot:[`item.price`]="{ item }">
                        <p class="my-0">$ {{ item.price }}</p>
                    </template>
                    <template v-slot:[`item.usable_free_value`]="{ item }">
                        <p class="my-0">
                            $ {{ numberFormat(item.usable_free_value) }}
                        </p>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <div
                            v-if="!item.isGenericReserveRow"
                            class="d-flex justify-center"
                        >
                            <v-btn
                                v-if="
                                    item.free_use != '' &&
                                        item.free_use > 0 &&
                                        item.storage !== 1153 &&
                                        reserve.storage !== '1153'
                                "
                                small
                                icon
                                color="primary"
                                @click="openReserveForm(item)"
                                hide-details
                                :disabled="
                                    item.project_name != '' ||
                                        !selectedProject ||
                                        validateProject(item)
                                "
                            >
                                <v-icon>mdi-database-edit-outline</v-icon>
                            </v-btn>
                            <v-btn
                                small
                                icon
                                @click="openDialogReserve(item)"
                                v-if="projects.length > 0 && item.userIsPM"
                            >
                                <v-icon>mdi-database-arrow-left-outline</v-icon>
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- ADD RESERVE -->
        <v-dialog
            :retain-focus="false"
            persistent
            v-model="reserveForm"
            :width="$vuetify.breakpoint.mobile ? '80%' : '40%'"
        >
            <AddReserve
                v-if="reserveForm"
                :item="selectedItem"
                @closeDialog="closeReserveForm"
                @reserve="reserve"
            />
        </v-dialog>
        <!--Release Reserve-->
        <v-dialog
            :retain-focus="false"
            v-model="openReserve"
            persistent
            :width="$vuetify.breakpoint.mobile ? '80%' : '40%'"
        >
            <ReleaseReserve
                v-if="openReserve"
                :item="selectedItem"
                @closeDialog="closeDialogReserve"
                @release="release"
            />
        </v-dialog>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import AddReserve from '@/components/StockRoom/AddReserve.vue'
import _ from 'lodash'
import { auth } from '@/services/firebase'
import ReleaseReserve from '@/components/StockRoom/ReleaseReserve.vue'
import { GENERIC_STOCK_PROJECT_IDS } from '@/constants/genericStockProjects'

export default {
    name: 'ItemReserve',
    props: {
        item: {
            type: Object,
            default: () => {},
        },
        projectId: {
            type: String,
            default: () => undefined,
        },
        users: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        AddReserve,
        ReleaseReserve,
    },
    data: () => ({
        height: 0,
        loading: false,
        headers: [
            {
                text: 'PROJECT',
                value: 'project_name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'STORE',
                value: 'storage',
                align: 'center',
                sortable: false,
            },
            {
                text: 'STORE NAME',
                value: 'storeName',
                align: 'center',
                sortable: false,
            },
            {
                text: 'QTY',
                value: 'free_use',
                align: 'left',
            },
            {
                text: 'PRICE (UNIT)',
                value: 'price',
                align: 'left',
            },
            {
                text: 'TOTAL PRICE',
                value: 'usable_free_value',
                align: 'left',
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                align: 'center',
                sortable: false,
                width: '100px',
            },
        ],
        selectedProject: null,
        projects: [],
        selectedItem: undefined,
        reserveForm: false,
        userId: '',
        openReserve: false,
        projectsInView: [],
        genericReserveRows: [],
    }),
    computed: {
        tableItems() {
            return [...(this.item.items || []), ...this.genericReserveRows]
        },
    },
    async mounted() {
        try {
            this.userId = auth().currentUser.uid
            this.projects = await API.getLiteProjectsByUser()
            if (this.projectId) {
                this.selectedProject = this.projectId
            }
            this.item.items.forEach(item => {
                const total = Number(
                    typeof item.usable_free_value == 'string'
                        ? item.usable_free_value.replace(/\./gi, '')
                        : item.usable_free_value
                )
                const available = Number(this.getDisplayQuantity(item))
                if (available == 0) {
                    item.price = 0
                } else {
                    item.price = new Intl.NumberFormat('de-DE').format(
                        Math.ceil(total / available)
                    )
                }
            })
            const validateProjects = await API.getProjectsBySapCode({
                codes: this.item.items.map(item => item.order),
            })
            for (const item of this.item.items) {
                if (item.order && item.order !== '') {
                    try {
                        const findProject = validateProjects.find(
                            project =>
                                String(project.sapCode) === String(item.order)
                        )

                        if (findProject) {
                            const projectManagerInfo = this.users.find(
                                user => user.id === findProject.projectManager
                            )
                            const projectManagerName = projectManagerInfo
                                ? projectManagerInfo.name
                                : undefined
                            this.$set(
                                item,
                                'userIsPM',
                                findProject.projectManager
                                    ? findProject.projectManager === this.userId
                                    : false
                            )
                            this.$set(
                                item,
                                'pm_name',
                                projectManagerName ?? 'No PM'
                            )
                        } else {
                            this.$set(item, 'pm_name', 'No PM')
                        }
                    } catch (error) {
                        console.error(
                            `Error fetching project for reference ${item.order}:`,
                            error
                        )
                    }
                }
            }

            await this.loadGenericReserveRows()
            this.onResize()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async release(release) {
            try {
                this.loading = true
                await API.releaseReserve({
                    ...(this.selectedItem.project_name
                        ? { stockItem: this.selectedItem }
                        : {
                              reserveId: this.selectedItem.id,
                              projectId: this.selectedItem.projectId,
                          }),
                    targetProjectId: release.projectId,
                    quantity: release.quantity,
                    notes: release.notes,
                })
                this.closeDialogReserve()
                this.close()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        openDialogReserve(item) {
            this.openReserve = true
            this.selectedItem = _.cloneDeep(item)
        },
        closeDialogReserve() {
            this.openReserve = false
            this.selectedItem = {}
        },
        validateProject() {
            const index = this.projects.findIndex(
                project => project.id == this.selectedProject
            )
            if (index >= 0) {
                const project = this.projects[index]
                return (
                    project.accountManager !== this.userId &&
                    project.projectManager !== this.userId &&
                    !project.collaborators.includes(this.userId || false)
                )
            }
            return false
        },
        closeReserveForm() {
            this.reserveForm = false
            this.selectedItem = undefined
        },
        parseQuantity(value) {
            if (value === undefined || value === null || value === '') {
                return 0
            }
            return Number(
                typeof value === 'string'
                    ? value.replace(/\./gi, '')
                    : value
            ) || 0
        },
        getSapAssignedQtyByOrderAndStorage(stockRows) {
            const totals = {}
            stockRows.forEach(row => {
                const order = row.order || row.orderNumber
                if (!order) {
                    return
                }
                const storage = String(row.storage)
                const key = `${String(order)}::${storage}`
                totals[key] =
                    (totals[key] || 0) + this.parseQuantity(row.free_use)
            })
            return totals
        },
        async loadGenericReserveRows() {
            if (!GENERIC_STOCK_PROJECT_IDS.length || !this.item?.code) {
                this.genericReserveRows = []
                return
            }
            const materialCode = this.item.code
            const stockRows = this.item.items || []
            const sapByOrderStorage =
                this.getSapAssignedQtyByOrderAndStorage(stockRows)
            const pendingRows = []

            const reserveLists = await Promise.all(
                GENERIC_STOCK_PROJECT_IDS.map(projectId =>
                    API.getReserves(projectId, 'approved').catch(() => [])
                )
            )

            for (let i = 0; i < GENERIC_STOCK_PROJECT_IDS.length; i++) {
                const projectId = GENERIC_STOCK_PROJECT_IDS[i]
                const reserves = reserveLists[i] || []
                let project = this.projects.find(p => p.id === projectId)
                if (!project?.sapCode) {
                    try {
                        project = await API.getProject(projectId)
                    } catch (error) {
                        continue
                    }
                }
                if (!project?.sapCode) {
                    continue
                }

                const grouped = {}
                reserves.forEach(reserve => {
                    if (reserve.type && reserve.type !== 'reserve') {
                        return
                    }
                    if (reserve.code !== materialCode) {
                        return
                    }
                    const storage = String(reserve.item?.storage ?? '')
                    const groupKey = storage
                    if (!grouped[groupKey]) {
                        grouped[groupKey] = {
                            qty: 0,
                            totalValue: 0,
                            storeName: reserve.item?.storeName || '',
                        }
                    }
                    const qty = this.parseQuantity(reserve.quantity)
                    const price = this.parseQuantity(reserve.price)
                    grouped[groupKey].qty += qty
                    grouped[groupKey].totalValue += qty * price
                })

                Object.keys(grouped).forEach(storage => {
                    const agg = grouped[storage]
                    const sapKey = `${String(project.sapCode)}::${storage}`
                    const sapQty = sapByOrderStorage[sapKey] || 0
                    const pendingQty = Math.max(0, agg.qty - sapQty)
                    if (pendingQty <= 0) {
                        return
                    }
                    const unitPrice =
                        agg.qty > 0 ? agg.totalValue / agg.qty : 0
                    pendingRows.push({
                        project_name: project.name,
                        storage,
                        storeName: agg.storeName,
                        free_use: pendingQty,
                        order: project.sapCode,
                        usable_free_value: pendingQty * unitPrice,
                        price: new Intl.NumberFormat('de-DE').format(
                            Math.ceil(unitPrice)
                        ),
                        isGenericReserveRow: true,
                        userIsPM: false,
                        pm_name: '—',
                        projectId,
                    })
                })
            }

            for (const row of pendingRows) {
                const findProject = this.projects.find(
                    p => p.id === row.projectId
                )
                if (findProject?.projectManager) {
                    const projectManagerInfo = this.users.find(
                        user => user.id === findProject.projectManager
                    )
                    row.pm_name = projectManagerInfo?.name ?? 'No PM'
                    row.userIsPM =
                        findProject.projectManager === this.userId
                }
            }

            this.genericReserveRows = pendingRows
        },
        getDisplayQuantity(item) {
            if (item.isGenericReserveRow) {
                return this.parseQuantity(item.free_use)
            }
            const rawValue =
                item.project_name === '' &&
                item.adjustedFreeUse !== undefined &&
                item.adjustedFreeUse !== null
                    ? item.adjustedFreeUse
                    : item.free_use
            return typeof rawValue == 'string'
                ? rawValue.replace(/\./gi, '')
                : rawValue
        },
        openReserveForm(item) {
            this.selectedItem = _.cloneDeep({
                ...item,
                free_use: this.getDisplayQuantity(item),
                adjustedFreeUse: this.getDisplayQuantity(item),
            })
            this.reserveForm = true
        },
        onResize() {
            const {
                title: { clientHeight: titleHeight },
                subtitle: { clientHeight: subtitleHeight },
                searchField: { clientHeight: searchFieldHeight },
            } = this.$refs
            this.height =
                window.innerHeight -
                titleHeight -
                subtitleHeight -
                searchFieldHeight -
                35
        },
        async reserve() {
            try {
                this.loading = true
                const itemToReserve = {
                    order: this.selectedItem.order,
                    free_use: Number(
                        typeof this.selectedItem.free_use == 'string'
                            ? this.selectedItem.free_use.replace(/\./gi, '')
                            : this.selectedItem.free_use
                    ),
                    price: Number(this.selectedItem.price.replace(/\./gi, '')),
                    project_name: this.selectedItem.project_name,
                    reserve: Number(this.selectedItem.reserve),
                    storage: Number(this.selectedItem.storage),
                    storeName: this.selectedItem.storeName,
                    usable_free_value: Number(
                        typeof this.selectedItem.usable_free_value == 'string'
                            ? this.selectedItem.usable_free_value.replace(
                                  /\./gi,
                                  ''
                              )
                            : this.selectedItem.usable_free_value
                    ),
                }
                const project = this.projects.find(
                    project => project.id === this.selectedProject
                )
                const reserve = {
                    projectId: this.selectedProject,
                    projectName: project.name,
                    code: this.item.code,
                    description: this.item.description,
                    quantity: itemToReserve.reserve,
                    price: itemToReserve.price,
                    total: itemToReserve.reserve * itemToReserve.price,
                    item: itemToReserve,
                    notes: this.selectedItem.notes || '',
                }
                await API.createReserve(reserve)
                this.closeReserveForm()
                this.close()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.$emit('closeDialog')
        },
        numberFormat(value) {
            return new Intl.NumberFormat('de-DE').format(Math.ceil(value))
        },
    },
}
</script>

<style>
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}
</style>
